import React from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';
import FormForgotPasswordSetNewView from './FormForgotPasswordSetNew-view';
import {checkRequiredValues} from 'common/utils/form/checkRequiredValues';
import {errors as E} from "common/constants/errors";
import {cognitoErrors as CE} from "common/constants/errors";


const FormForgotPasswordSetNew = ({stepContext, messagePopup, showGlobalErrorMessage}) => {
  const initialValues = {
    verificationCode: stepContext.verificationCode || '',
    newPassword: '',
    newPasswordConfirm: ''
  };

  const validate = values => {
    const {newPassword, newPasswordConfirm} = values;
    let errors = {};
    errors = checkRequiredValues(values, errors);
    if (newPassword !== newPasswordConfirm) {
      errors.newPasswordConfirm = E.PASSWORDS_DONT_MATCH;
    }

    return errors;
  };

  const handleSubmit = values => {
    const {newPassword, verificationCode} = values;
    const {cognitoUser, closeModal} = stepContext;

    cognitoUser.confirmPassword(verificationCode, newPassword, {
      onSuccess() {
        closeModal();
      },
      onFailure(err) {
        showGlobalErrorMessage(CE[err.name] || JSON.stringify(err));
        console.error(err);
      },
    });

  };

  return (
    <Formik
      initialValues={initialValues}
      validate={validate}
      onSubmit={handleSubmit}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={false}
    >
      {(formikProps) => (
        <>
        <FormForgotPasswordSetNewView
          {...formikProps}
        />
          {messagePopup}
        </>
      )}
    </Formik>
  )
};

FormForgotPasswordSetNew.propTypes = {
  stepContext: PropTypes.object,
};

export default FormForgotPasswordSetNew;
